<template>
  <b-modal id="ai-score-guide-modal"
           class="ai-score-guide-modal"
           ref="modal"
           centered
           hide-header
           hide-footer>
    <div class="ai-score-guide-modal__main">
      <div class="ai-score-guide-modal__header text-right">
        <img
          src="/static/images/score-guide-close.svg"
          alt="close modal"
          class="clickable"
          @click="$refs.modal.hide()"
        />
      </div>

      <div class="ai-score-guide-modal__body">
        <div
          class="ai-score-guide-modal__title text-center"
          v-html="$t('ai_report.score_guide.title')"
        />

        <div
          class="ai-score-guide-modal__description text-center mx-auto"
          v-html="$t('ai_report.score_guide.description')"
        />

        <div class="ai-score-guide-modal__score-list text-center">
          <div class="ai-score-guide-modal__score-list-item" v-for="i in aiGradeCount" :key="i">
            <div class="ai-score-guide-modal__score-label">
              {{ $t(`ai_report.score_guide.score_label_${i}`) }}
            </div>

            <div class="ai-score-guide-modal__score-value">
              {{ $t(`ai_report.score_guide.score_value_${i}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'ai-score-guide-modal',

    data() {
      return {
        aiGradeCount: 12,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .ai-score-guide-modal__main {
    background-image: url('/static/images/bg-my-level-info.jpg');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .ai-score-guide-modal__header {
    margin-bottom: 10px;

    @media (min-width: 576px) {
      padding: 7px 15px;
      margin-bottom: 19px;
    }
  }

  .ai-score-guide-modal__body {
    padding-bottom: 15px;

    @media (min-width: 576px) {
      padding-bottom: 65px;
    }
  }

  .ai-score-guide-modal__title {
    font-size: 18px;
    font-weight: bold;
    line-height: 22px;
    color: #00c896;
    opacity: 0.87;
    margin-bottom: 20px;

    @media (min-width: 576px) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .ai-score-guide-modal__description {
    font-size: 12px;
    line-height: 1.25;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.87;
    max-width: 388px;
    margin-bottom: 16px;

    @media (min-width: 576px) {
      font-size: 16px;
      margin-bottom: 36px;
    }
  }

  .ai-score-guide-modal__score-list-item {
    display: inline-block;
    margin-bottom: 6px;

    @media (min-width: 576px) {
      margin-bottom: 14px;
    }
  }

  .ai-score-guide-modal__score-label {
    display: inline-block;
    width: 148px;
    font-size: 14px;
    line-height: 26px;
    color: rgba(0, 0, 0, 0.54);
    text-align: left;

    @media (min-width: 576px) {
      margin-right: 26px;
    }
  }

  .ai-score-guide-modal__score-value {
    display: inline-block;
    width: 100px;
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    color: #00c896;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/AiScoreGuideModal.vue